import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  TextField,
  Grid,
  CircularProgress,
  Button,
  Paper,
  InputLabel,
  FormHelperText,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";

import { AgGridReact } from "ag-grid-react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {getCategoryById, deleteCategory, updateCategory} from "../../api/asset";
import { handleAxiosError } from "../../config/action-config";
import { Controller, useForm } from "react-hook-form";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { showAlert } from "../../actions/alert";

const deleteApis = {
  CATEGORY: deleteCategory,
};

const emptyCategoryData = {
  category: "",
  description: "", 
};

export default function ViewCategory() {
  const {
    control,
    formState: { errors },
  } = useForm();
  const user = useSelector((state) => state.user);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [categoryData, setCategoryData] = useState(emptyCategoryData);
  const [assignedTo, setassignedTo] = useState("")
  const [deletingContent, setDeletingContent] = useState({ table: "", row: 0 });
  const [editDisabled, setEditDisabled] = useState(true);

  const onCategoryDataUpdate = () => {
    updateCategory(categoryData.id, getUpdatableCategoryData(categoryData), user.token)
      .then((res) => {
        loadMasterData();
        dispatch(showAlert(res.data.msg));
        setEditDisabled(true);
        //navigate("/");
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  const loadMasterData = () => {
    getCategoryById(params.id, user.token)
      .then((res) => {
        setCategoryData(res.data.categoriesdetail);
        setLoading(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  useEffect(() => {
    if (!params.id) {
    } else {
      loadMasterData();
    };
  }, [params.id]);

  const changeUpdateData = (e) => {
    setCategoryData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onDelete = () => {
    const deleteApi = deleteApis[deletingContent.table];
    deleteApi(deletingContent.row, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setDeletingContent({ type: "", row: 0 });
        if (deletingContent.table === "CATEGORY") {
          navigate("/category");
        }
      })
      .catch((err) => {
        setDeletingContent({ table: "", row: 0 });
        handleAxiosError(err, dispatch);
      });
  };

  return loading ? (
    <Loading />
  ) : (
    <Box sx={{ flexGrow: 1}}>
      <Paper sx={{ p: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            borderBottom: 1,
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Category Details</Typography>
          <Box sx={{ display: "flex", columnGap: 1 }}>
            <Button
              variant="contained"
              onClick={() => {
                setEditDisabled((prev) => !prev);
              }}
              style={{ padding: "5px 7px" }}
            >
              {editDisabled ? "Edit" : "Cancel"}
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setDeletingContent({ table: "CATEGORY", row: categoryData.id });
              }}
              className="blue-button"
            >
              Delete
            </Button>
          </Box>
        </Box>
        <Grid container spacing={2} sx={{ pt: "1rem" }}>
          <Grid item xs={12} sm={6} md={6}> 
            <TextField
              fullWidth
              name="category"
              onChange={changeUpdateData}
              value={categoryData.category}
              size="small"
              label="Category"
              type="text"
              className="name-textfeild"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}> 
            <TextField
              fullWidth
              name="description"
              onChange={changeUpdateData}
              value={categoryData.description}
              size="small"
              label="Description"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={12}>
            {editDisabled ? (
              <></>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  columnGap: 1,
                  ml: "auto",
                }}
              >
                <Button
                  variant="contained"
                  onClick={onCategoryDataUpdate}
                  style={{ padding: "5px 7px" }}
                  className="blue-button"
                >
                  Update
                </Button>
              </Box>
            )}
          </Grid>
        </Grid>
      </Paper>

      <DeleteDialog
        deletingContent={deletingContent}
        setDeletingContent={setDeletingContent}
        onDelete={onDelete}
      />
    </Box>
  );
}

function DeleteDialog({ deletingContent, setDeletingContent, onDelete }) {
  return (
    <Dialog
      open={Boolean(deletingContent.table)}
      onClose={() => {
        setDeletingContent({ table: "", row: 0 });
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          This will delete the row in table {deletingContent.table} with id:{" "}
          {deletingContent.row}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setDeletingContent({ table: "", row: 0 });
          }}
          className="cancel-button"
        >
          Cancel
        </Button>
        <Button onClick={onDelete} autoFocus className="blue-button">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Loading() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <CircularProgress />
      </div>
    </div>
  );
}

function getUpdatableCategoryData(data) {
  return {
    category: data.category,
    description: data.description, 
  };
}
